<template>
  <div class="container">
    <div class="banner">
      <el-image :src="src3" style=""></el-image>
    </div>
    <div class="main">
      <div style="font-size: 28px;font-weight: bold;padding: 20px;">
        推荐新人活动说明
      </div>
      <div style="text-align: left">
        <h3>1、如何获得？</h3>
        <p>通过【推荐会员】获得，【新用户】在<span style="color: #ff4d4f">首次</span>购买产品时输入推荐会员的手机号
          <span style="color: #ff4d4f">（推荐会员的手机号在账号有效期内）</span>
          ，购买完成后，购买者和推荐人的两个手机 号将同时获得相同的积分。</p>
        <el-image :src="src1" style="height: 260px;width: 520px;margin-left: 100px"></el-image>
        <p></p>
        <h3>2、积分规则？</h3>
        <p>根据产品的类型进行积分：</p>
        <p>▶ 1个月产品积分5</p>
        <p>▶ 12个月产品积分10</p>
        <p>▶ 24月产品积分20</p>
        <p>▶ 长期有效产品积分50</p>
        <p></p>
        <h3>3、如何使用？</h3>
        <el-image :src="src2" style="height: 350px;width: 520px;margin-left: 100px"></el-image>
        <p>购买产品时，<span style="color: #ff4d4f">在最高使用积分额度以下，</span>按1积分抵扣1元的方式直接抵扣产品金额。额度规则如下：</p>
        <el-table
          :data="tableData"
          max-height="600px">
          <el-table-column property="title" label="产品" width="200" header-align="center" align="center"></el-table-column>
          <el-table-column property="max1" label="1个月" width="120" header-align="center" align="center"></el-table-column>
          <el-table-column property="max2" label="12个月" width="120" header-align="center" align="center"></el-table-column>
          <el-table-column property="max3" label="24个月" width="120" header-align="center" align="center"></el-table-column>
          <el-table-column property="max4" label="长期有效" width="120" header-align="center" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getPrice } from '@/utils/tabList'
import img1 from '@/assets/images/promotion_1.png'
import img2 from '@/assets/images/promotion_2.png'
import img3 from '@/assets/images/promotion_3.png'
export default {
  name: 'Promotion',
  components: {
    // HelloWorld,
    // FixedHeader
  },
  data() {
    return {
      tableData: [],
      src1: img1,
      src2: img2,
      src3: img3
    }
  },
  created() {
    getPrice().then((res) => {
      const tabList = res
      tabList.map(item => {
        this.tableData.push({
          'title': item.title,
          'max1': item.values[0].max / 100,
          'max2': item.values[1].max / 100,
          'max3': item.values[2].max / 100,
          'max4': item.values[3].max / 100
        })
      })
    })
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.container{
  //position: relative;
  width: calc(100vw);
  //height: calc(100vh - 220px);
  background: #f0f0f0;
  margin-top: 65px;
  padding-bottom: 5px;
}
.main{
  background: white;
  margin-left: calc((100vh - 475px) / 2);
  margin-right: calc((100vh - 475px) / 2);
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 20px;
  padding-left: 45px;
  text-align: center;
}
.banner{
  //background: #fc5316;
  background: -webkit-linear-gradient(#fc5316, #fa8257); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#fc5316, #fa8257); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#fc5316, #fa8257); /* Firefox 3.6 - 15 */
  background: linear-gradient(#fc5316, #fa8257); /* 标准的语法（必须放在最后） */
  height: 200px;
  text-align: center;
  margin-bottom: 10px
}
</style>

